import React, { useState } from "react";
import { emailUrl } from "../baseUrl";
import { markInquirySubmitted } from "../utils";

interface InquiryFormProps {
  onSuccess?: () => void;
}

export const InquiryForm: React.FC<InquiryFormProps> = ({ onSuccess }) => {
  const [formValues, setFormValues] = useState({
    name: "",
    phone: "",
    queryType: "",
    address: "",
  });

  const [sending, setSending] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSending(true);
    setErrorMsg("");
    setSuccessMsg("");

    try {
      const res = await fetch(emailUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(formValues),
      });

      if (res.ok) {
        setSuccessMsg("Message sent successfully!");

        // 🔐 Persist + notify gate
        markInquirySubmitted();
        onSuccess?.();

        setFormValues({
          name: "",
          phone: "",
          queryType: "",
          address: "",
        });
      } else {
        const data = await res.json();
        const error =
          data?.errors?.[0]?.message ||
          "Something went wrong. Please try again.";
        setErrorMsg(error);
      }
    } catch (err) {
      setErrorMsg("Network error. Please try again later.");
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <input
        name="name"
        type="text"
        placeholder="Full Name"
        value={formValues.name}
        onChange={handleChange}
        required
        className="w-full border border-gray-300 rounded px-4 py-2 focus:ring-2 focus:ring-blue-300"
      />

      <input
        name="phone"
        type="tel"
        placeholder="Phone Number"
        value={formValues.phone}
        onChange={handleChange}
        required
        className="w-full border border-gray-300 rounded px-4 py-2 focus:ring-2 focus:ring-blue-300"
      />

      <select
        name="queryType"
        value={formValues.queryType}
        onChange={handleChange}
        required
        className="w-full border border-gray-300 rounded px-4 py-2 focus:ring-2 focus:ring-blue-300"
      >
        <option value="">Select Query Type</option>
        <option value="SAINIK SCHOOL">SAINIK SCHOOL</option>
        <option value="RMS">RMS</option>
        <option value="RIMC">RIMC</option>
        <option value="NAVODAYA">NAVODAYA</option>
      </select>

      <textarea
        name="address"
        placeholder="Address"
        rows={4}
        value={formValues.address}
        onChange={handleChange}
        required
        className="w-full border border-gray-300 rounded px-4 py-2 resize-none focus:ring-2 focus:ring-blue-300"
      />

      {errorMsg && <p className="text-red-600 text-sm">{errorMsg}</p>}
      {successMsg && <p className="text-green-600 text-sm">{successMsg}</p>}

      <button
        type="submit"
        disabled={sending}
        className="w-full bg-blue-800 text-white py-2 rounded hover:bg-blue-900 transition disabled:opacity-70 flex items-center justify-center"
      >
        {sending ? "Sending..." : "Submit"}
      </button>
    </form>
  );
};
